module.exports = __webpack_public_path__ + "img/audio.61a9a024.png";